import { Leaf, Camera, PencilSimple, Plant, MagnifyingGlass, ArrowsClockwise, Question, CheckCircle, X, type Icon as PhosphorIcon } from '@phosphor-icons/react';

const ICONS: Record<string, PhosphorIcon> = {
  leaf: Leaf,
  camera: Camera,
  pencil: PencilSimple,
  plant: Plant,
  search: MagnifyingGlass,
  reset: ArrowsClockwise,
  question: Question,
  check: CheckCircle,
  close: X,
};

interface IconProps {
  name: keyof typeof ICONS;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 20, className = '' }: IconProps): JSX.Element {
  const Cmp = ICONS[name];
  return <span className={className}><Cmp size={size} weight="duotone" /></span>;
}
